import React from "react";
import { IoClose } from "react-icons/io5";
import styles from "./CommonModal.module.scss";

function CommonModal({ isOpen, onClose, title, children ,widthHeight}) {
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={widthHeight ? styles.modalContentLarge : styles.modalContentSmall}>
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full bg-red-200 hover:bg-red-300 transition shadow"
        >
          <IoClose size={20} className="text-red-600" />
        </button>

        {/* Header */}
        {title && (
          <div className="rounded-t-2xl bg-gradient-to-r from-blue-500 to-indigo-600 p-4 mb-4 shadow-md">
            <h2 className="text-lg sm:text-xl font-semibold text-white text-center">
              {title}
            </h2>
          </div>
        )}

        {/* Body */}
        <div>{children}</div>
      </div>
    </div>
  );
}

export default CommonModal;
